import Enum from "../../../../../enums/Enum";

const InvoiceUpdateReasonEnum = new Enum({
    WRONG_CODE: "Wrong code used (diagnosis, procedure, or modifier error)",
    SERVICE_MISMATCH: "Service mismatch (what was done vs. what was ordered)",
    MISSING_DOCUMENTATION: "Missing or unclear notes (provider's documentation not complete)",
    DUPLICATE_CHARGES: "Duplicate charges (same service billed more than once)",
    DATA_ENTRY_ERROR: "Data entry mistakes (typos, wrong numbers, missing info)",
    SYSTEM_ERROR: "System errors (software glitch, downtime, or integration failure)",
    OUTDATED_INFO: "Old or wrong patient/insurance details",
    PREAUTH_PENDING: "Pre-authorization still pending (approval not received in time)",
    CONTRACT_DISPUTE: "Contract/payment disputes (insurance disagrees on rates or coverage)",
    PAYMENT_CORRECTION: "Under/overpayments found late (needs correction)",
    PRICE_MISMATCH: "Price/quantity mismatch (what's billed vs. agreed)",
    POLICY_CHANGES: "Policy/tax changes (new rules affecting billing)",
    REFUND: "Refund",
    OTHER: "Other"
});

export default InvoiceUpdateReasonEnum;